import React from 'react';
import { motion } from 'framer-motion';
import { Map, Target, Zap, ArrowRight, Activity, Users } from 'lucide-react';
export function Slide1Opening() {
  const stages = [{
    name: 'Pre-Congress',
    icon: Users
  }, {
    name: 'Vicinity',
    icon: Map
  }, {
    name: 'Venue',
    icon: Target
  }, {
    name: 'Aisle',
    icon: Zap
  }, {
    name: 'Booth',
    icon: Activity
  }, {
    name: 'Post-Congress',
    icon: ArrowRight
  }];
  return <div className="h-full w-full bg-[#F8F9FA] text-[#2D3748] flex flex-col p-12 md:px-24 md:pt-20 md:pb-28 relative overflow-hidden" data-id="element-81">
      {/* Background accents */}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-gradient-to-l from-white to-transparent pointer-events-none z-0" data-id="element-82" />
      <div className="absolute -top-[20%] -right-[10%] w-[60%] h-[60%] rounded-full bg-[#E60012]/5 blur-3xl pointer-events-none" data-id="element-83" />
      <div className="absolute -bottom-[20%] -left-[10%] w-[50%] h-[50%] rounded-full bg-[#6B46C1]/5 blur-3xl pointer-events-none" data-id="element-84" />

      <main className="flex-1 flex flex-col justify-center z-10 max-w-5xl" data-id="element-85">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-86">
          <div className="flex items-center gap-3 mb-6" data-id="element-87">
            <div className="w-12 h-[2px] bg-[#E60012]" data-id="element-88" />
            <span className="text-[#E60012] font-semibold tracking-wider uppercase text-sm" data-id="element-89">
              Takeda x Snakker
            </span>
          </div>
          <h1 className="text-5xl md:text-6xl font-bold leading-tight mb-6 text-[#1A202C]" data-id="element-90">
            Congress is not one event.
            <br data-id="element-91" />
            <span className="text-[#E60012]" data-id="element-92">
              It is a micro customer funnel.
            </span>
          </h1>
          <p className="text-xl text-[#4A5568] font-light max-w-3xl leading-relaxed mb-16" data-id="element-93">
            Snakker helps Takeda map the full congress journey, identify the
            biggest engagement bottleneck and solve one focused use case at a
            time.
          </p>
        </motion.div>

        {/* Funnel Roadmap Visual */}
        <motion.div className="relative w-full mt-8" initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.3
      }} data-id="element-94">
          <div className="absolute top-1/2 left-0 w-full h-1 bg-gradient-to-r from-[#E60012]/20 via-[#E60012] to-[#E60012]/20 -translate-y-1/2 rounded-full" data-id="element-95" />

          <div className="relative flex justify-between items-center w-full" data-id="element-96">
            {stages.map((stage, index) => {
            const Icon = stage.icon;
            return <motion.div key={stage.name} className="flex flex-col items-center relative group" initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 0.5,
              delay: 0.4 + index * 0.1
            }} data-id="element-97">
                  <div className="w-16 h-16 rounded-full bg-white shadow-lg border-2 border-[#E60012]/10 flex items-center justify-center mb-4 relative z-10 group-hover:border-[#E60012] transition-colors duration-300" data-id="element-98">
                    <Icon className="w-6 h-6 text-[#E60012]" data-id="element-99" />
                  </div>
                  <span className="text-sm font-semibold text-[#2D3748]" data-id="element-100">
                    {stage.name}
                  </span>
                  {index < stages.length - 1 && <div className="absolute top-8 left-[100%] w-full h-[2px] bg-transparent" data-id="element-101" />}
                </motion.div>;
          })}
          </div>
        </motion.div>

        <motion.div className="mt-16 bg-white p-6 rounded-xl shadow-sm border border-gray-100 max-w-4xl" initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 1
      }} data-id="element-102">
          <p className="text-[#4A5568] text-sm leading-relaxed" data-id="element-103">
            <strong className="text-[#1A202C]" data-id="element-104">The methodology:</strong> A
            congress is a compressed customer journey. HCPs move through
            different levels of attention, curiosity, interest and commitment
            before, during and after the event. Each step has a different job.
          </p>
        </motion.div>
      </main>
    </div>;
}